import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { queryGetPendingEOD } from "@type/api/management";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

export const useGetPendingEOD = () => {
  const { buSlug } = useParams();

  const getTicketDetailsQuery = useMemo(
    () =>
      queryGetPendingEOD._key({
        idBu: buSlug || "",
      }),
    [buSlug]
  );

  const {
    isLoading: isLoadingGetPendingEOD,
    data,
    refetch,
  } = useQueryWithCallbacks({
    queryKey: getTicketDetailsQuery,
    enabled: !!buSlug,
    queryFn: () => queryGetPendingEOD({ idBu: buSlug || "" }),
  });

  return {
    pendingEOD: data,
    isLoadingGetPendingEOD,
    refetchPendingEOD: refetch,
  };
};
